module.exports = __webpack_public_path__ + "static/img/JWST_1_R_20221003_LC.31523fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/JWST_1_R_20221003_LC.png
// module id = Fb8a
// module chunks = 0